import { Icon } from 'antd'
import { IIconProps } from 'common/components/icons/inner/IIconProps'
import React from 'react'

/**
 * ICONE: Mais conteúdo (Detalhes)
 * @author Lucas Rosa
 */
export const MoreContentIconCP = (props: IIconProps): JSX.Element => {

    return (
        <Icon
            type={'menu-fold'}
            style={{
                fill: props.color ?? 'inherit',
                color: props.color ?? 'inherit',
                fontSize: props.size ?? '20px',
                ...props.style
            }}
        />
    )
}
